/**
 * logo.dev image URLs — single place for token, path shape, and query params.
 * Prefer {@link logo} / {@link logo} instead of building strings at call sites.
 */

const LOGO_DEV_ORIGIN = "https://img.logo.dev";

export const LOGO_DEV_TOKEN = process.env.NEXT_PUBLIC_LOGO_DEV_TOKEN;

export type LogoDevParams = {
  domain?: string | null;
  name?: string | null;
  size?: number;
  format?: "png" | "jpg" | "webp";
  /**
   * When `false`, only returns a URL if `domain` is set (no `/name/...` fallback).
   * @default true
   */
  nameFallback?: boolean;
};

/** Bare domain from whatever the user typed ("https://www.acme.com/x" → "acme.com"). */
export function websiteToDomain(website: string): string | null {
  const domain = website
    .trim()
    .replace(/^https?:\/\//, "")
    .replace(/^www\./, "")
    .split("/")[0];
  return domain || null;
}

export function logo(params: LogoDevParams): string | null {
  if (!LOGO_DEV_TOKEN) return null;

  const nameFallback = params.nameFallback !== false;
  const domain = params.domain?.trim() || null;
  const name = params.name?.trim() || null;

  let path: string | null = null;
  if (domain) {
    path = `${LOGO_DEV_ORIGIN}/${domain}`;
  } else if (nameFallback && name) {
    path = `${LOGO_DEV_ORIGIN}/name/${encodeURIComponent(name)}`;
  }

  if (!path) return null;

  const qs = new URLSearchParams({ token: LOGO_DEV_TOKEN });
  if (params.size != null) qs.set("size", String(params.size));
  if (params.format) qs.set("format", params.format);

  return `${path}?${qs.toString()}`;
}
